import styled from 'styled-components';

import { fadeIn } from '../../styles/shared.style';

export const WrapperNaming = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: space-between;
    width: 787px;
    height: 100%;
    padding-bottom: 16px;
    gap: 16px;

    @media (max-width: 1200px) {
        justify-content: flex-start;
        gap: 8px;
        width: 100%;
    }
`;

export const WrapperTicketInfo = styled.div<{$error: boolean}>`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: auto;
    border-radius: 8px;
    padding: 16px;
    gap: 16px;
    background-color: ${({ theme }) => theme.colors.surface.high};

    border: 1px solid ${({ theme, $error }) => theme.colors[$error ? 'error' : 'border']};

    @media (max-width: 1200px) {
        width: 100%;
    }
`;

export const WrapperTicketTitle = styled.div`
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;

    @media (max-width: 1200px) {
        align-items: flex-start;
    }
`;

export const ContainerTitle = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-between;
    gap: 8px;
    
`;

export const Title = styled.h1`
    font-family: 'Elza', sans-serif;
    font-size: 16px;
    font-weight: 600;
    line-height: 19.36px;
    text-align: left;
    padding: 0;
    margin: 0;

`;

export const Subtitle = styled.h2`
    font-family: 'Elza', sans-serif;
    font-size: 14px;
    font-weight: 400;
    line-height: 16.94px;
    text-align: left;
    padding: 0;
    margin: 0;
    color: ${({ theme }) => theme.colors.button.text.disabled};
`;

export const ContainerTag = styled.div`
    width: 242px;
    height: auto;
    gap: 8px;
`;

export const WrapperInput = styled.form`
    display: grid;
    width: 100%;
    grid-template-columns: 4fr 1fr;

    @media (max-width: 1200px) {
        grid-template-columns: 1fr;
        grid-template-rows: 1fr 1fr;
        gap: 8px;
    }
`;

export const ContainerInput = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
`;

export const InputForm = styled.input<{$containsError: boolean}>`
  width: 100%;
  gap: 16px;
  border-radius: 8px;
  opacity: 0px;
  border: 1px solid ${({ theme, $containsError }) => $containsError ? theme.colors.error : theme.colors.border};
  padding: 8px 44px 8px 12px;
  font-size: 14px;
  font-weight: 500;
  color: ${({ theme, $containsError }) => $containsError ? theme.colors.error : theme.colors.text.primary};
  outline: none;
  box-sizing: border-box;
  animation: ease-out, ${fadeIn} 0.5s ease-out;
`;

export const NamingButton = styled.button`
    background-color: transparent;
    color: ${({ theme }) => theme.colors.button.text.disabled};
    font-family: 'Elza', sans-serif;
    font-size: 16px;
    font-weight: 700;
    line-height: 19.36px;
    text-align: center;
    padding: 0;
    margin: 0;
    color: ${({ theme }) => theme.colors.button.text.secondary};
    margin-top: -2px;

    &:hover {
        background-color: transparent;
    }

    @media (max-width: 1200px) {
        font-size: 14px;
    }

    &:disabled {
        background-color: #fff;
        cursor: not-allowed;
        color: ${({ theme }) => theme.colors.button.text.disabled};
    }
`;

export const ErrorText = styled.span`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.error};
  margin-top: 4px;
  margin-left: 8px;
`;

export const EmailIcon = styled.img`
    position: absolute;
    right: 16px;
`;

export const TransferDescriptionParagraph = styled.p`
    color: #637381;
    font-size: 12px;
`;
